import { useEffect, useRef, useState } from 'react'

import { Box, Chip, Divider, Grid, Typography } from '@mui/material'
import { GAME_TOPIC_FILTERS, GameType } from 'constants/enums/GameTypeEnum'

import GameCard from 'components/GameCard/GameCard'

import { styles } from './GameCardSection.styles'

export type Props = {
	divider?: boolean
	filter?: boolean
	games: GameType[]
	padding: string
	title: string
}

const GameCardSection = (props: Props) => {
	const elRef = useRef<null | HTMLDivElement>(null)
	// Add game name to empty string below to indicate a game coming soon
	const comingSoonList = ['']

	const [gameValue, setSelectedGameValue] = useState<number | null>(null)
	const [selectedFilter, setSelectedFilter] = useState<string | null>(null)

	useEffect(() => {
		elRef.current?.scrollIntoView({
			behavior: 'smooth',
			block: 'center',
		})
		selectedFilter !== null &&
			setTimeout(() => setSelectedFilter(null), 4000)
	}, [selectedFilter])

	const onGameFilterClick = (value: string) => {
		setSelectedFilter(value)
		if (value === 'Operations') {
			setSelectedGameValue(3)
			return
		}
		setSelectedGameValue(4)
	}

	return (
		<>
			<Grid
				data-testid="home__content_subtitle"
				item
				px={6}
				sx={styles.homePage}
				xs={12}
			>
				<Typography data-testid="home__subheader" sx={styles.subheader}>
					{props.title}
				</Typography>
			</Grid>
			{props.filter && (
				<Grid
					data-testid="game-card-section-filter"
					container
					sx={styles.outerFiltersContainer}
				>
					<Box
						data-testid="home__filter-pills"
						sx={styles.innerFiltersContainer}
					>
						<Typography
							data-testid="game-card-section__filter-label"
							sx={styles.filerLabel}
						>
							Filter by topic:
						</Typography>
						{Object.entries(GAME_TOPIC_FILTERS).map(
							([key, value]) => (
								<Chip
									label={value}
									variant={'outlined'}
									key={key}
									onClick={() => {
										onGameFilterClick(value)
									}}
									data-testid={`game-filter-chip-${value.toLowerCase().replace(' ', '-')}`}
									sx={styles.chip}
								/>
							)
						)}
					</Box>
				</Grid>
			)}
			<Box
				data-testid="home__game_card_container"
				sx={{
					...styles.gameCardContainer,
					marginBottom: props.padding,
				}}
			>
				<Grid container sx={styles.gameCardContent}>
					{props.games.map((game, index) => (
						<Grid
							data-testid="home__game_card"
							key={game.value}
							ref={
								selectedFilter !== null &&
								game.value === gameValue
									? elRef
									: undefined
							}
							item
							xs={12}
							lg={6}
							sx={{
								...styles.gameCardContainerCardGridItem,
								...(selectedFilter !== null &&
								!game.filters.includes(selectedFilter)
									? styles.opacity25
									: styles.opacity100),
								xs: styles.center,
								lg:
									index % 2 === 0
										? styles.flexStart
										: styles.flexEnd,
							}}
						>
							<GameCard
								gameTypeEnum={game}
								comingSoonList={comingSoonList}
							/>
						</Grid>
					))}
					{props.divider && (
						<Grid
							data-testid="game-card-section-divider"
							item
							xs={10}
							lg={12}
							sx={styles.gameCardContainerBaseGridItem}
						>
							<Divider
								data-testid="home__game_card_container_bottom_divider"
								sx={styles.gameCardBottomDivider}
							></Divider>
						</Grid>
					)}
				</Grid>
			</Box>
		</>
	)
}

export default GameCardSection
